import { useState } from 'react';
import dayjs from 'dayjs';
import 'dayjs/locale/es'; // importa y registra el locale
dayjs.locale('es'); // activa el idioma español

const initGraph = {
  labels: [],
  datasets: [],
  total: 0,
};

export const useMedicamentosIniciadoAutorizadoTotales = ({
  mensualList,
  anualList,
  mensualDate,
  anualDate,
}) => {
  const [dataAutorizadosAnual, setDataAutorizadosAnual] = useState(initGraph);
  const [dataAutorizadosMensual, setDataAutorizadosMensual] = useState(initGraph);
  const [dataIniciadosAnual, setDataIniciadosAnual] = useState(initGraph);
  const [dataIniciadosMensual, setDataIniciadosMensual] = useState(initGraph);
  const [dataDemora0_3Anual, setDataDemora0_3Anual] = useState(initGraph);
  const [dataDemora4_7Anual, setDataDemora4_7Anual] = useState(initGraph);
  const [dataDemora7MasAnual, setDataDemora7MasAnual] = useState(initGraph);

  const getTramitesAnual = () => {
    const anioActual = dayjs(anualDate).year();
    const labels = Array.from({ length: 12 }, (_, i) => {
      const fecha = dayjs().year(anioActual).month(i);
      return {
        month: fecha.format('MMM'),
        date: fecha.format('YYYY-MM'),
      };
    });

    const datasetPendientes = labels.map((mes) => {
      const fechaLabel = dayjs(mes.date, 'YYYY-MM');

      return anualList
        .filter((item) => {
          const fechaItem = dayjs(item.fecha_dia, 'YYYY-MM');
          return fechaItem.isSame(fechaLabel, 'month');
        })
        .reduce((acc, item) => acc + item.cantidad_pendientes, 0);
    });

    const datasetAutorizados = labels.map((mes) => {
      const fechaLabel = dayjs(mes.date, 'YYYY-MM');

      return anualList
        .filter((item) => {
          const fechaItem = dayjs(item.fecha_dia, 'YYYY-MM');
          return fechaItem.isSame(fechaLabel, 'month');
        })
        .reduce((acc, item) => acc + item.cantidad_autorizados, 0);
    });

    const labelsMonth = labels.map((l) => l.month);
    setDataIniciadosAnual({
      labels: labelsMonth,
      datasets: [
        {
          data: datasetPendientes,
          fill: true,
          borderColor: 'rgba(244, 139, 54, 0.9)',
          backgroundColor: 'rgba(235, 53, 53, 0.2)',
          tension: 0.3,
          pointRadius: 0,
        },
      ],
      total: datasetPendientes.reduce((acc, item) => acc + item, 0),
    });

    setDataAutorizadosAnual({
      labels: labelsMonth,
      datasets: [
        {
          data: datasetAutorizados,
          fill: true,
          borderColor: 'rgba(53, 223, 235, 0.9)',
          backgroundColor: 'rgba(0,191,166,0.2)',
          tension: 0.3,
          pointRadius: 0,
        },
      ],
      total: datasetAutorizados.reduce((acc, item) => acc + item, 0),
    });
  };

  const getTramitesAnualDemoras = () => {
    const anioActual = dayjs(anualDate).year();
    const labels = Array.from({ length: 12 }, (_, i) => {
      const fecha = dayjs().year(anioActual).month(i);
      return {
        month: fecha.format('MMM'),
        date: fecha.format('YYYY-MM'),
      };
    });

    const datasetDemora0_3 = labels.map((mes) => {
      const fechaLabel = dayjs(mes.date, 'YYYY-MM');

      return anualList
        .filter((item) => {
          const fechaItem = dayjs(item.fecha_dia, 'YYYY-MM');
          return fechaItem.isSame(fechaLabel, 'month');
        })
        .reduce((acc, item) => acc + item.demora_0_3_dias, 0);
    });

    const datasetDemora4_7 = labels.map((mes) => {
      const fechaLabel = dayjs(mes.date, 'YYYY-MM');

      return anualList
        .filter((item) => {
          const fechaItem = dayjs(item.fecha_dia, 'YYYY-MM');
          return fechaItem.isSame(fechaLabel, 'month');
        })
        .reduce((acc, item) => acc + item.demora_4_7_dias, 0);
    });

    const datasetDemora7Mas = labels.map((mes) => {
      const fechaLabel = dayjs(mes.date, 'YYYY-MM');

      return anualList
        .filter((item) => {
          const fechaItem = dayjs(item.fecha_dia, 'YYYY-MM');
          return fechaItem.isSame(fechaLabel, 'month');
        })
        .reduce((acc, item) => acc + item.demora_mas_7_dias, 0);
    });

    const labelsMonth = labels.map((l) => l.month);

    setDataDemora0_3Anual({
      labels: labelsMonth,
      datasets: [
        {
          data: datasetDemora0_3,
          fill: true,
          borderColor: 'rgba(76, 175, 80, 0.9)',
          backgroundColor: 'rgba(76, 175, 80, 0.2)',
          tension: 0.3,
          pointRadius: 0,
        },
      ],
      total: datasetDemora0_3.reduce((acc, item) => acc + item, 0),
    });

    setDataDemora4_7Anual({
      labels: labelsMonth,
      datasets: [
        {
          data: datasetDemora4_7,
          fill: true,
          borderColor: 'rgba(255, 193, 7, 0.9)',
          backgroundColor: 'rgba(255, 193, 7, 0.2)',
          tension: 0.3,
          pointRadius: 0,
        },
      ],
      total: datasetDemora4_7.reduce((acc, item) => acc + item, 0),
    });

    setDataDemora7MasAnual({
      labels: labelsMonth,
      datasets: [
        {
          data: datasetDemora7Mas,
          fill: true,
          borderColor: 'rgba(235, 53, 53, 0.9)',
          backgroundColor: 'rgba(235, 53, 53, 0.2)',
          tension: 0.3,
          pointRadius: 0,
        },
      ],
      total: datasetDemora7Mas.reduce((acc, item) => acc + item, 0),
    });
  };

  const getTramitesMensual = () => {
    const currentDate = dayjs(mensualDate);
    const diasEnMes = currentDate.daysInMonth();
    const labels = Array.from({ length: diasEnMes }, (_, i) => {
      return {
        day: i + 1,
        date: currentDate.date(i + 1).format('YYYY-MM-DD'),
      };
    });

    const datasetPendientes = labels.map((dia) => {
      const fechaLabel = dayjs(dia.date, 'YYYY-MM-DD');
      return mensualList
        .filter((item) => {
          const fechaItem = dayjs(item.fecha_dia, 'YYYY-MM-DD');
          return fechaItem.isSame(fechaLabel, 'day');
        })
        .reduce((acc, item) => acc + item.cantidad_pendientes, 0);
    });

    const datasetAutorizados = labels.map((dia) => {
      const fechaLabel = dayjs(dia.date, 'YYYY-MM-DD');
      return mensualList
        .filter((item) => {
          const fechaItem = dayjs(item.fecha_dia, 'YYYY-MM-DD');

          return fechaItem.isSame(fechaLabel, 'day');
        })
        .reduce((acc, item) => acc + item.cantidad_autorizados, 0);
    });

    const labelsDays = labels.map((l) => l.day);
    setDataIniciadosMensual({
      labels: labelsDays,
      datasets: [
        {
          data: datasetPendientes,
          fill: true,
          borderColor: 'rgba(244, 139, 54, 0.9)',
          backgroundColor: 'rgba(235, 53, 53, 0.2)',
          tension: 0.3,
          pointRadius: 0,
        },
      ],
      total: datasetPendientes.reduce((acc, item) => acc + item, 0),
    });

    setDataAutorizadosMensual({
      labels: labelsDays,
      datasets: [
        {
          data: datasetAutorizados,
          fill: true,
          borderColor: 'rgba(53, 223, 235, 0.9)',
          backgroundColor: 'rgba(0,191,166,0.2)',
          tension: 0.3,
          pointRadius: 0,
        },
      ],
      total: datasetAutorizados.reduce((acc, item) => acc + item, 0),
    });
  };

  return {
    dataIniciadosAnual,
    dataIniciadosMensual,
    dataAutorizadosAnual,
    dataAutorizadosMensual,
    dataDemora0_3Anual,
    dataDemora4_7Anual,
    dataDemora7MasAnual,
    getTramitesAnual,
    getTramitesMensual,
    getTramitesAnualDemoras,
  };
};
